import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['shadow', 0.24],
        ['well', 0.76],
      ],
      d: 'M-1,-2h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM-1.5,-1h0.5v0.5h-0.5zM1,-1h1v0.5h-1zM-2.5,-0.5h1v0.5h-1zM1.5,-0.5h1v0.5h-1zM-2.5,0h5v0.5h-5zM-1.5,0.5h3v0.5h-3z',
    },
    {
      paint: [
        ['sail', 0.22],
        ['well', 0.78],
      ],
      d: 'M-1,-2.5h1v0.5h-1zM0.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM1,-2h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v1h-0.5zM-2.5,-1h1v0.5h-1zM-1.5,-0.5h3v0.5h-3z',
    },
    {
      paint: 'shadow',
      d: 'M-1.5,-1.5h1v0.5h-1zM0.5,-1.5h1v0.5h-1zM-1,-1h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5z',
    },
    { paint: 'rock', d: 'M1.5,0.5h0.5v0.5h-0.5z' },
    {
      paint: 'trunk',
      d: 'M2.5,-5.5h0.5v0.5h-0.5zM-3.5,-4.5h0.5v0.5h-0.5zM-3,-4h2v0.5h-2zM1.5,-4h0.5v0.5h-0.5zM-2,-3.5h1.5v0.5h-1.5zM0.5,-3.5h1.5v0.5h-1.5zM-2,-3h0.5v2h-0.5zM1.5,-3h0.5v2h-0.5zM-0.5,-1h1v0.5h-1z',
    },
    {
      paint: 'roofB',
      d: 'M-1,-6.5h0.5v0.5h-0.5zM-1.5,-6h1v0.5h-1zM-2,-5.5h1.5v0.5h-1.5zM-2.5,-5h2.5v0.5h-2.5zM-2,-4.5h2v0.5h-2z',
    },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-0.5,-6.5h0.5v0.5h-0.5zM-0.5,-6h2v0.5h-2zM-0.5,-5.5h3v0.5h-3zM0,-5h2.5v0.5h-2.5zM-2.5,-4.5h0.5v0.5h-0.5zM0,-4.5h1.5v0.5h-1.5zM-0.5,-4h1v0.5h-1z',
    },
    { paint: 'fence', d: 'M-0.5,-3h1v0.5h-1zM0,-2.5h0.5v0.5h-0.5z' },
    {
      paint: 'barrel',
      d: 'M2.5,-5h0.5v0.5h-0.5zM-3,-4.5h0.5v0.5h-0.5zM1.5,-4.5h1v0.5h-1zM-1,-4h0.5v0.5h-0.5zM0.5,-4h1v0.5h-1zM-0.5,-3.5h1v0.5h-1zM-0.5,-1.5h1v0.5h-1z',
    },
    { paint: 'cart', d: 'M-0.5,-2h1v0.5h-1z' },
  ],
  pixels: 124,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
